import { trafficStatusMapApi } from '../apis';

class trafficStatusService {
  async getTrafficStatus(data) {
    const rs = await trafficStatusMapApi.getTrafficStatus(data);
    return rs;
  }
  async getTrafficStatusV2(data) {
    const rs = await trafficStatusMapApi.getTrafficStatusV2(data);
    return rs;
  }
  async getTrafficStatusRectangle(data) {
    const rs = await trafficStatusMapApi.getTrafficStatusRectangle(data);
    return rs;
  }
  async getTrafficStatusCircle(data) {
    const rs = await trafficStatusMapApi.getTrafficStatusCircle(data);
    return rs;
  }
}

const trafficStatusMapService = new trafficStatusService();

export default trafficStatusMapService; 